var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pdfViewer",staticClass:"pdf-viewer",class:{ 'p-relative--20px': _vm.urlFrom === 'detail' }},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Loading PDF...")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7c1a912","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PdfViewer.vue
// module id = 577
// module chunks = 1 2 4 5 6 8